import { Box, Grid, Typography, useMediaQuery } from '@mui/material'
import React from 'react'
import MotionAppear from '../../Components/MotionAppear';
import { theme } from '../../Resources/Design/theme';
import { useFirestore } from '../../Firebase/FirestoreProvider';
import EditableImage from '../../Components/EditableImage';
import { useAuth } from '../../Firebase/AuthProvider';
import { fullCenter, pastelBlue, pastelRed } from './constants';

export default function Photogalery() {
    const mobile = useMediaQuery(theme.breakpoints.only("xs"));
    const tablet = useMediaQuery(theme.breakpoints.only("sm"));
    const { isAdmin } = useAuth();
    const { data, changeData } = useFirestore();
    const fotogalerie = data?.fotogallery || [];

    let selectedImages = mobile ? fotogalerie.slice(0, 6) : fotogalerie;
    if (tablet && !mobile) {
        if (selectedImages.length % 2 !== 0) {
            selectedImages = selectedImages.slice(0, selectedImages.length - 1);
        }
    }

    return (
        <Box>
            <Grid container columnSpacing={2} rowSpacing={4} columns={24}>
                {selectedImages.map((img, i) => <Grid item key={"TemaProgram" + i} id={"TPId" + i} xs={24} sm={12} md={8} sx={{ display: 'flex', justifyContent: 'center', /*pt: '0px !important'*/ }}>
                    <MotionAppear amount={0.2} style={{ width: '100%' }}>
                        <EditableImage alt={`obrázek z fotobanky ${i}`} path={`fotogallery.${i}`}
                            sx={{ borderRadius: '20px', width: '100%', minHeight: { xs: '400px', sm: '340px' }, height: { xs: '400px', sm: '340px' }, objectFit: 'cover', objectPosition: "center", boxShadow: '1px 1px 2px 0px rgba(0,0,0,0.2)', }} />
                    </MotionAppear>
                </Grid>)}
            </Grid>
            {isAdmin && <Box sx={{ display: 'flex', flexDirection: 'row' }}><Box component='span'
                sx={{
                    width: '34px', height: '34px', maxWidth: '34px', maxHeight: '34px', minWidth: '34px', borderRadius: '50%',
                    bgcolor: pastelBlue,
                    scale: 1,
                    transition: 'scale 0.2s ease-in-out',
                    "&:hover": { scale: 1.05 },
                    zIndex: 14, cursor: 'pointer', ...fullCenter, mt: '12px'
                }}
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const newOftenAsked = [...fotogalerie, ""]
                    changeData('fotogallery', newOftenAsked);

                }} onMouseDown={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                }}>

                <Typography sx={{ fontWeight: 'bold', fontSize: '28px', mb: '4px' }}>+</Typography>
            </Box>
                <Box component='span'
                    sx={{
                        width: '34px', height: '34px', maxWidth: '34px', maxHeight: '34px', minWidth: '34px', borderRadius: '50%',
                        bgcolor: pastelRed,
                        scale: 1,
                        transition: 'scale 0.2s ease-in-out',
                        "&:hover": { scale: 1.05 }, ml: '12px',
                        zIndex: 14, cursor: 'pointer', ...fullCenter, mt: '12px'
                    }}
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        const newOftenAsked = [...fotogalerie].slice(0, -1);
                        changeData('fotogallery', newOftenAsked);

                    }} onMouseDown={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                    }}>

                    <Typography sx={{ fontWeight: 'bold', fontSize: '28px', mb: '4px' }}>-</Typography>
                </Box>
            </Box>}
        </Box>
    )
}
